import { render, staticRenderFns } from "./planet-next-prev-box.vue?vue&type=template&id=5a9ecd7e&"
import script from "./planet-next-prev-box.vue?vue&type=script&lang=js&"
export * from "./planet-next-prev-box.vue?vue&type=script&lang=js&"
import style0 from "./planet-next-prev-box.vue?vue&type=style&index=0&id=5a9ecd7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports